module.exports = __webpack_public_path__ + "img/level-0.998c37e2.jpg";